export const productsData = [
  {
    id: 1,
    title: "Door Closers",
    category: "Architectural Hardware",
    description: "High-quality compact, scissor arm, track arm and heavy-duty door closers",
    image: "image/doorClose.jpg",
  },
  {
    id: 2,
    title: "Engine Liners",
    category: "Automotive & Industrial Components",
    description: "Precision-manufactured engine liners for multiple applications",
    image: "image/linerforpdf.png",
  },
  {
    id: 3,
    title: "Submersible Pumps & Motors",
    category: "Pumps & Motors",
    description: "ISI-certified submersible pump sets for agricultural and industrial use",
    image: "image/pumpforpdf.png",
  },
  {
    id: 4,
    title: "Commercial Gas Stoves & Kitchen Equipment",
    category: "Commercial Kitchen Equipment",
    description: "Professional-grade gas stoves and kitchen solutions",
    image: "image/mainStove.png",
  },
];
